import React from "react";

const products = [
  {
    id: 1,
    name: "Build your own computer",
    sku: "COMP_CUST",
    price: "$1,200.00",
    stock: 10000,
    published: true,
    image:
    "https://rukminim2.flixcart.com/image/832/832/xif0q/computer/i/y/t/-original-imahgx8whbcmquff.jpeg?q=70&crop=false",
  },
  {
    id: 2,
    name: "Digital Storm VANQUISH Custom Performance PC",
    sku: "DS_VA3_PC",
    price: "$1,259.00",
    stock: 10000,
    published: true,
    image:
"https://i.dell.com/is/image/DellContent/content/dam/ss2/product-images/dell-client-products/notebooks/alienware-notebooks/aa18250/media-gallery/laptop-alienware-aa18250nt-gallery-1.psd?fmt=png-alpha&pscan=auto&scl=1&hei=402&wid=486&qlt=100,1&resMode=sharp2&size=486,402&chrss=full",
  },
  {
    id: 3,
    name: "Lenovo IdeaCentre",
    sku: "LE_IC_600",
    price: "$500.00",
    stock: 10000,
    published: true,
    image:
    "https://www.livemint.com/lm-img/img/2024/08/29/600x338/best_laptops_1724918310587_1724918318071.jpg",
  },
  {
    id: 4,
    name: "Apple MacBook Pro",
    sku: "AP_MBP_13",
    price: "$1,800.00",
    stock: 10000,
    published: true,
    image:
    "https://www.notebookcheck.net/fileadmin/_processed_/webp/Notebooks/Sonstiges/bestmobilelaptops-q82-w2560-h.webp",
  },
  {
    id: 5,
    name: "Asus Laptop",
    sku: "AS_551_LP",
    price: "$1,500.00",
    stock: 10000,
    published: true,
    image:
    "https://i.dell.com/is/image/DellContent/content/dam/ss2/product-images/dell-client-products/notebooks/dell-plus/db16255/media-gallery/non-touch/laptop-dell-plus-db16255nt-ice-bl-fpr-gallery-5.psd?fmt=png-alpha&pscan=auto&scl=1&hei=804&wid=979&qlt=100,1&resMode=sharp2&size=979,804&chrss=full",
  },
  {
    id: 6,
    name: "Samsung Premium Ultrabook",
    sku: "SM_900_PU",
    price: "$1,590.00",
    stock: 10000,
    published: true,
    image:
    "https://cdn.mos.cms.futurecdn.net/DrtQXEghAMemrBL8X5xUP.jpg",
  },
];

export default function ProductsList2() {
  return (
    <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold text-gray-700">
            Learn more about <span className="text-blue-600">products</span>
          </h2>
        </div>

        <table className="w-full border-collapse text-sm text-gray-700">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="p-3 text-left">
                <input type="checkbox" className="w-4 h-4 ml-16" />
              </th>
              <th className="p-3 text-left">Picture</th>
              <th className="p-3 text-left">Product name</th>
              <th className="p-3 text-left">SKU</th>
              <th className="p-3 text-left">Price</th>
              <th className="p-3 text-left">Stock quantity</th>
              <th className="p-3 text-left">Published</th>
              <th className="p-3 text-left">Edit</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, index) => (
              <tr  key={p.id}
                className={`border-b ${
                  index % 2 === 0 ? "bg-gray-50" : "bg-white "
                }`}>
                <td className="p-3">
                  <input type="checkbox" className="w-4 h-4 ml-16" />
                </td>
                <td className="p-3">
                  <img  src={p.image}alt={p.name}
                    className="w-16 h-16 object-cover rounded border"/>
                </td>
                <td className="p-3 font-medium text-gray-800">{p.name}</td>
                <td className="p-3">{p.sku}</td>
                <td className="p-3">{p.price}</td>
                <td className="p-3">{p.stock}</td>
                <td className="p-3">
                  {p.published ? (
                    <span className="text-blue-600 text-xl">✔</span>
                  ) : (
                    <span className="text-gray-400 text-xl">✖</span>
                  )}
                </td>
                <td className="p-3">
                  <button className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded text-sm flex items-center gap-1">
                    ✏️ Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
